import { BottomNavigationAction } from './Action/BottomNavigationAction';
import { BottomNavigation as BottomNavigationRoot } from './BottomNavigation';

export const BottomNavigation = Object.assign(BottomNavigationRoot, {
  Action: BottomNavigationAction,
});
